<template>
    <div class="loading-screen">
        <span>LOADING<span>{{percentage}}%</span></span>
    </div>
</template>

<script>
import store from '@/dataStore';

export default {
    name: 'LoadingScreen',
    props: {},
    data()
    {
        return {
            percentage: 0
        }
    },
    created()
    {
        this.unsubscribeFromStore = store.subscribe((storeState)=>{
            if (storeState.imagesToLoad > 0)
            {
                this.percentage = Math.round(storeState.imagesLoaded / storeState.imagesToLoad * 100);
            }
            else
            {
                this.percentage = 0;
            }
        });
    },
    unmounted()
    {
        this.unsubscribeFromStore();
    }
}
</script>
